import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { AssetType } from "../assets/asset-labels";
import { assetTypes } from "@/assets/asset-labels";
import type { RootState } from "@/store";

/**
 * Stores filter configuration for metrics page
 */

interface MetricsFilterState {
  wharvesFilter: string[];
  assetTypesFilter: AssetType[];
}

const initialState: MetricsFilterState = {
  wharvesFilter: [],
  assetTypesFilter: [...assetTypes],
};

export const mapSlice = createSlice({
  name: "metricsFilter",
  initialState,
  reducers: {
    setWharvesFilter: (
      state,
      { payload: wharves }: PayloadAction<string[]>,
    ) => {
      state.wharvesFilter = wharves;
    },
    setAssetTypesFilter: (
      state,
      { payload: assetTypes }: PayloadAction<AssetType[]>,
    ) => {
      state.assetTypesFilter = assetTypes;
    },
  },
});

export default mapSlice.reducer;
export const { setAssetTypesFilter, setWharvesFilter } = mapSlice.actions;
export function selectWharvesFilter(state: RootState): string[] {
  return state.metricsFilter.wharvesFilter;
}
export function selectAssetTypesFilter(state: RootState): AssetType[] {
  return state.metricsFilter.assetTypesFilter;
}
